import React, { useCallback, useEffect, useState } from "react";
import { serviceGetList } from "../../../services/Common.service";
import { useDispatch, useSelector } from "react-redux";
import { serviceIncentiveRulesList } from "../../../services/IncentiveRule.service";
import { updateIncentiveRulesForm } from "../../../actions/IncentiveRules.action";
import historyUtils from "../../../libs/history.utils";
import RouteName from "../../../routes/Route.name";

function useIncentiveRulesHook() {
  const [isLoading, setIsLoading] = useState(false);
  const [data,setData] = useState({})
  const form = useSelector((state) => state.incentive_rules_form);
  const dispatch = useDispatch();

  const [listData, setListData] = useState({
    FY_YEAR: [],
  });

  useEffect(() => {
    serviceGetList(["FY_YEAR"]).then((res) => {
      if (!res.error) {
        setListData(res.data);
      }
    });
  }, []);


  useEffect(() => {
  if (form?.fy_year && form?.quarter) {
    setIsLoading(true);

    Promise.all([
      serviceIncentiveRulesList({
        quarter: form?.quarter,
        fy_year: form?.fy_year,
      }),
      serviceGetList(["PRODUCT_CATEGORIES"]),
    ])
      .then(([ruleRes, listRes]) => {
        const incentiveData = ruleRes?.data || {};
        const categoryList = listRes?.data?.PRODUCT_CATEGORIES || [];

        const categories = (incentiveData.categories || []).map((cat) => {
          const category = categoryList.find(
            (item) => item.id === cat.category_id
          );

          return {
            ...cat,
            name: category?.name || "",
          };
        });

        setData({
          ...incentiveData,
          categories,
        });

        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }
}, [form]);

  const changeTextData = useCallback(
    (text, fieldName) => {
      const updatedForm = { ...form };
      updatedForm[fieldName] = text;
      dispatch(updateIncentiveRulesForm(updatedForm));
    },
    [form, dispatch]
  );

  console.log("form", form);

  const handleDetail = useCallback(() => {
    historyUtils.push(`${RouteName.INCENTIVE_RULES_CREATE}`);
  }, []);

  return {
    form,
    changeTextData,
    listData,
    handleDetail,
    data
  };
}

export default useIncentiveRulesHook;
